import {DefaultService} from "@/services/DefaultService";

class CatalogoService extends DefaultService{

    constructor(url: string) {
        super(url);
    }

}

export {CatalogoService};